import { render } from "./DateInput.vue?vue&type=template&id=488fb5f6&ts=true"
import script from "./DateInput.vue?vue&type=script&lang=ts"
export * from "./DateInput.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__